/**
 * The archive rules, mirrored from the backend settings
 * (TASK_ARCHIVE_AFTER_DAYS / TASK_ARCHIVE_CANCELED_AFTER_DAYS) so the UI
 * can say what will happen. projects/task-archive, A3.
 */
export const ARCHIVE_AFTER_DAYS = 7;
export const ARCHIVE_CANCELED_AFTER_DAYS = 1;

/** "1 task" / "3 tasks". */
export const taskCount = (n) => `${n} ${n === 1 ? "task" : "tasks"}`;
